import React from 'react';
import Button from '@mui/material/Button';
import { brand } from 'themes/brand';
import CircularProgress from '@mui/material/CircularProgress';

interface ButtonMainProps {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
}

const ButtonMain: React.FC<ButtonMainProps> = ({
  onClick,
  text,
  disabled = false,
  loading = false,
}) => {
  const customStyles = {
    width: '100%',
    maxWidth: '512px',
    padding: '8px 27px',
    alignSelf: 'center',
    borderRadius: '4px',
    border: 'none',
    background: brand.primary,
    boxShadow: '0 4px 14px rgba(0, 91, 255, 0.35)',
  };

  const disabledStyles = {
    width: '100%',
    maxWidth: '512px',
    padding: '8px 27px',
    alignSelf: 'center',
    borderRadius: '4px',
    border: '1px solid #C9D3E6',
    background: brand.border,
    color: brand.textSecondary,
  };

  // Conditionally apply styles based on the disabled prop
  const buttonStyle = disabled ? disabledStyles : customStyles;

  return loading ? (
    <Button>
      <CircularProgress />
    </Button>
  ) : (
    <Button
      variant="contained"
      style={buttonStyle}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </Button>
  );
};

export default ButtonMain;
